module.exports = __webpack_public_path__ + "static/media/humanitarian-need.7cec1208.png";